interface IconProps {
  color?: string
  className?: string
}

export default function EventTabIcon({ color, className }: IconProps) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.875 11.375V7.875H6.125V12.25H1.75C1.25781 12.25 0.875 11.8672 0.875 11.375ZM7.875 12.25V7.875H13.125V11.375C13.125 11.8672 12.7148 12.25 12.25 12.25H7.875ZM13.125 3.5C13.5898 3.5 14 3.91016 14 4.375V6.5625C14 6.80859 13.7812 7 13.5625 7H0.4375C0.191406 7 0 6.80859 0 6.5625V4.375C0 3.91016 0.382812 3.5 0.875 3.5H2.07812C1.88672 3.17188 1.80469 2.81641 1.80469 2.40625C1.80469 1.09375 2.87109 0 4.21094 0C5.33203 0 6.07031 0.601562 7.02734 1.88672C7.95703 0.601562 8.69531 0 9.84375 0C11.1562 0 12.25 1.09375 12.25 2.40625C12.25 2.81641 12.1406 3.17188 11.9492 3.5H13.125ZM4.18359 3.5H6.5625C5.14062 1.42188 4.73047 1.3125 4.18359 1.3125C3.58203 1.3125 3.08984 1.80469 3.08984 2.40625C3.08984 3.03516 3.58203 3.5 4.18359 3.5ZM9.84375 3.5C10.4453 3.5 10.9375 3.03516 10.9375 2.40625C10.9375 1.80469 10.4453 1.3125 9.84375 1.3125C9.26953 1.3125 8.88672 1.42188 7.46484 3.5H9.84375Z"
        fill={color ?? '#ffffff'}
      />
    </svg>
  )
}
